import React                        from 'react';
import PropTypes                    from 'prop-types';
import Flux                         from '../../../flux/Flux';
import Translations                 from '../../../utils/Translations';
import DailybonusTodayOfferHeadLine from './DailybonusTodayOfferHeadLine';
import VipBadge                     from '../SubComponents/VipBadge';
import OfferIcon                    from '../SubComponents/OfferIcon';
import DailyBonusOfferBtn           from '../SubComponents/DailyBonusOfferBtn';
import {
	formatEffectAsPlainText, needVipYesterdayOffer,
}                                   from '../dailyBonusHelpers';

const {offers, signature, offerBgs} = Flux.Constants.DailyBonuses;

const DailybonusTodayTopUpOffer = props => {
	const {offer, purchased, conditions, effect} = props;
	const needVip                                = needVipYesterdayOffer(conditions);
	const backgroundImg                          = offer === offers.TOP_UP_PERCENT ? offerBgs.TOP_UP_PERCENT : offerBgs.TOP_UP_FLAT;
	const backgroundUrl                          = `url(${backgroundImg})`;
	const signatureTxt                           = offer === offers.TOP_UP_PERCENT ? signature.TOP_UP_PERCENT : signature.TOP_UP_FLAT;

	return (
		<div className='dailybonus-today-item'>
			<DailybonusTodayOfferHeadLine
				purchased={purchased}
				offer={offer}
			/>
			<div className="dailybonus-today-item__wrapper">
				<div className="dailybonus-today-item__left-side" style={{backgroundImage: backgroundUrl}}>
					<div className="dailybonus-today-item__left-side--bottom-plate">
						<div className="dailybonus-today-item__left-side--bottom-plate__signature">{signatureTxt}</div>
					</div>
				</div>
				<div className="dailybonus-today-item__right-side">
					<VipBadge conditions={conditions} />
					<div className="dailybonus-today-item__right-side__icon"><OfferIcon offer={offer} purchased={purchased} /></div>
					<div className="dailybonus-today-item__right-side__offer-effect">{formatEffectAsPlainText(effect)}</div>
					<div className="dailybonus-today-item__right-side__title">{needVip ? 'VIP BONUS' : 'BONUS'}</div>
					<div className="dailybonus-today-item__right-side__description h-text-light">{Translations.get('TopUpPercent365Charge')}</div>
					<DailyBonusOfferBtn
						purchased={purchased}
						offer={offer}
						effect={effect}
						conditions={conditions}
					/>
				</div>
			</div>
		</div>
	);
};

DailybonusTodayTopUpOffer.defaultProps = {
	conditions: [],
	purchased:  false,
	effect:     {},
};

DailybonusTodayTopUpOffer.propTypes = {
	conditions: PropTypes.array,
	offer:      PropTypes.string,
	purchased:  PropTypes.bool,
	effect:     PropTypes.shape({
		name:  PropTypes.string,
		value: PropTypes.string,
		unit:  PropTypes.string,
		code:  PropTypes.string,
	}),
};

export default DailybonusTodayTopUpOffer;
